/* eslint-disable no-param-reassign */
import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchNavigationData({ busNumber }) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/fetchNavigationData`;
  return newReconServiceAPI(url, {
    addOnFilter: { busNumber },
  });
}

export function fetchDayWiseBreakDown({
  pageNo = 0, pageSize = 10, busNumber, operationType = "", cityId = [], operatorId = [], dateFilter = "", sortBy,
}) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/dayWiseBreakDownCollectionData`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      busNumber,
      date: dateFilter,
      operatorIdArr: operatorId,
      cityIdArr: cityId,
      operationType,
    },
    pageNo,
    pageSize,
    sort: sortBy,
  });
}

export function fetchBreakDownSummary({
  cityFilter = [], busNumber = "", operatorId = [], dateFilter = "", operationType = "",
}) {
  const url = `${NEW_BASE_URL}/v1/collectionPage/collectionSummary`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      cityIdArr: cityFilter, busNumber, operatorIdArr: operatorId, date: dateFilter, operationType,
    },
    limit: 20,
  });
}

export function fetchDateDueBreakDown({
  pageNo = 0, pageSize = 10, dueId, search,
}) {
  const url = `${NEW_BASE_URL}/v1/settlementsPage/dateDueBreakDownCollectionData`;
  return newReconServiceAPI(url, {
    addOnFilter: {
      dueId,
    },
    search,
    pageSize,
    pageNo,
  });
}
